import React, { Component, Fragment, useState, useRef } from 'react';
import { ApiEndpoints } from '../../../../api/apiEndpoints';
import { ModalWindow } from '../../../modal/ModalWindow';

export function ShopItemCategoryDeleteModal({deleteCategoryId, setDeleteCategoryId, fetchCategories}) {
    const [submitting, setSubmitting] = useState(false);
    const modalWindowRef = useRef();
    const confirmDelete = async (e) => {
        if (submitting) return;
        setSubmitting(true);

        await fetch(`${ApiEndpoints.ManageShopItemCategories}/${deleteCategoryId}`, { method: "DELETE" });
        fetchCategories();
        modalWindowRef.current.closeWindow();
    }

    return (
        <ModalWindow
                    ref={modalWindowRef}
                    title="Confirm Delete"
                    onClose={() => setDeleteCategoryId(null)}
                >
            <p>Are you sure you want to delete this category?</p>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => modalWindowRef.current.closeWindow()}>Cancel</button>
              <button type="button" className="btn btn-danger" onClick={confirmDelete} disabled={submitting}>Delete</button>
            </div>
        </ModalWindow>
    );
}